export const PERMISSION_LEVEL = ["STAFF", "MANAGEMENT", "PERSIDENT"];
